import Glide from '@glidejs/glide'

(function(window, document) {
    'use strict';

    if(document.getElementById('main-slider_images')) {
        var image_slider = new Glide('#main-slider_images', {
          gap: 0
        }).mount();

        var text_slider = new Glide('#main-slider_captions', {
          dragThreshold: false
        }).mount();

        image_slider.on('run', (e) => {
            text_slider.go(e.direction);
        })

        text_slider.on('move.after', function (moveAmount) {
            let activeEl = document.getElementById('main-slider_captions').querySelectorAll('.glide__slide--active a');
            var disable_elements = document.getElementById('main-slider_captions').querySelectorAll(".glide__slide a");

            disable_elements.forEach((userItem) => {
                userItem.tabIndex = -1;
            });
            activeEl.forEach((userItem) => {
                userItem.tabIndex = 0;
            });
        });

        // image_slider.on( 'move.after', function( moveAmount ) {
        //     let activeEl = sliderEl.querySelector('.glide__slide--active');
        //     let becomingActive = activeEl.previousElementSibling;
        //     becomingActive.classList.remove('becoming-active');
        // } );
    }

})(window, document, Glide);
